import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";
import {
  createActualQuantitySchema,
  createAtcSchema,
  PORT_SERVICE_FIELDS_LANG_BASE,
  withAtcAfterAtsValidation,
} from "./sharedClosePortServiceSchemas";

const LANG_BASE = PORT_SERVICE_FIELDS_LANG_BASE;

const createServiceReportAttachmentSchema = () =>
  z.object({
    serviceReportAttachment: z
      .object({
        documentUrl: z.string().optional(),
        documentName: z.string().optional(),
        fileType: z.string().optional(),
      })
      .superRefine((val, ctx) => {
        const hasDocument = !!val?.documentUrl?.trim();

        if (!hasDocument) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["serviceReportAttachment"],
            message: i18n.t("form-validation.required", {
              label: i18n.t(`${LANG_BASE}.service-report`),
            }),
          });
        }
      }),
  });

export const closeDebunkeringSchema = (ats?: string | Date | null) =>
  withAtcAfterAtsValidation(
    (createAtcSchema("required") as z.AnyZodObject)
      .merge(createActualQuantitySchema())
      .merge(createServiceReportAttachmentSchema())
      .merge(notificationSchema),
    ats,
  );

export type CloseDebunkeringSchema = z.infer<ReturnType<typeof closeDebunkeringSchema>>;
